import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { InitDetailInbound } from '@root/state/reducers/inboundReducer/inboundReducers';
import { Card, Spin } from 'antd';
import {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import DetailInbound from '../components/DetailInbound';
import TableComplete from '../components/TableComplete';

interface ParamType {
  id: string;
}

function InboundDetail() {
  // handle api detail
  const { id } = useParams<ParamType>();

  const { getInboundDetailHandle } = useActions();
  const [canEdit, setCanEdit] = useState(false);
  const [commentAllId, setCommentAllId] = useState(0);

  useEffect(() => {
    getInboundDetailHandle(id);
  }, []);

  const { data, loading } = useTypedSelector<InitDetailInbound>(
    (state) => state.detailInboundReducer
  );

  const Breadcrumb = [
    {
      tittle: 'Inbound',
      url: '/admin/inbound'
    },
    {
      tittle: 'Detailed Inbound',
      url: ''
    }
  ];

  const editComplete = () => {
    setCanEdit(false);
  };

  useEffect(() => {
    getInboundDetailHandle(id);
  }, [canEdit]);

  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <Spin spinning={loading} className="loading-forgot">
        <div className="admin-container">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: '0px 24px',
              background: 'white',
              padding: '10px',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ display: 'flex' }}>
              <p
                style={{
                  marginBottom: '0px',
                  fontWeight: 'bold',
                  fontSize: '15px'
                }}
              >
                {data?.data?.name}
              </p>
              <p
                style={{
                  marginBottom: '0px',
                  marginLeft: '10px',
                  color: '#747274'
                }}
              >
                {data?.data?.email}
              </p>
            </div>
            {data?.data?.status && (
              <div>
                <p
                  style={{
                    marginBottom: '0px',
                    fontWeight: 'bold',
                    fontSize: '15px',
                    width: '150px',
                    marginLeft: 'auto',
                    display: 'block',
                    borderRadius: '20px',
                    padding: '6px 0px',
                    background: '#2B2C51',
                    color: 'white',
                    textAlign: 'center'
                  }}
                >
                  {data?.data?.status}
                </p>
              </div>
            )}
          </div>
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '100vh',
              background: 'none'
            }}
          >
            <div
              className=""
              style={{
                minHeight: '100vh',
                backgroundColor: 'white',
                padding: '30px 10px',
                borderRadius: '6px'
              }}
            >
              <DetailInbound canEdit={canEdit}
                             setCanEdit={(canEdit) => setCanEdit(canEdit)}
                             setCommentAllId={(commentId) => setCommentAllId(commentId)}

              />
            </div>
          </Card>
        </div>
        {(data?.data?.status === 'Approved' ||
          data?.data?.status === 'Delivered') && (
          <div className="admin-container">
            <div
              style={{
                alignItems: 'center',
                background: 'white',
                padding: '20px'
              }}
            >
              <TableComplete canEdit={canEdit} commentId={commentAllId} editComplete={editComplete}/>
            </div>
          </div>
        )}
      </Spin>
    </>
  );
}

export default InboundDetail;
